import NutriMart from "../components/NutriMart";

const Index = () => <NutriMart />;

export default Index;
